import { ProductType } from '@yme/common/constants';
import { QueryParams } from '@yme/components/ShoppingCart/constants';
import { ABB_PRODUCT_NAME_LOCALIZED_KEY, SIZE_KEY, COLOR_NAME_KEY, ROTATION_KEY, SHAFT_LENGTH_KEY, STARTING_METHOD_KEY, CONTROL_METHOD_KEY, G_CORE_PRODUCT_GROUP_NAME, } from '@yme/selectors/constants';
import { getAttributeByName, getImageSrc, getItemImage } from '@yme/utils/common';
import { ImageSuffix } from '@yme/utils/constants';
import { getMasterVariant, getPdpLinkByCategory, getProductURL } from '@yme/utils/product';
import { PRODUCT_DELIVER_AT_DEALER_ONLY, X20_GROUP_NAME } from './constants';
export function generateCartLink(cartId, dealerId) {
    const url = new URL(window.location.href);
    url.searchParams.set(QueryParams.CART_ID, cartId);
    url.searchParams.set(QueryParams.PRESELECTED_DEALER_ID, dealerId);
    return `${url.pathname}${url.search}${url.hash}`;
}
export function getProductsDataForEmail(entries, pdpLinks, isInAuthor) {
    return entries.map(({ product: { variants, categories, slug, type, name } }) => {
        const { attributes, images, sku } = variants[0];
        const itemImage = getItemImage(images);
        const path = getPdpLinkByCategory(pdpLinks, categories);
        const productLink = getProductURL({
            path,
            isInAuthor,
            slug,
            sku,
        });
        return {
            title: getAttributeByName(attributes, ABB_PRODUCT_NAME_LOCALIZED_KEY) || name,
            size: getAttributeByName(attributes, SIZE_KEY),
            colour: getAttributeByName(attributes, COLOR_NAME_KEY),
            rotation: getAttributeByName(attributes, ROTATION_KEY),
            shaftLength: getAttributeByName(attributes, SHAFT_LENGTH_KEY),
            startingMethod: getAttributeByName(attributes, STARTING_METHOD_KEY),
            controlMethod: getAttributeByName(attributes, CONTROL_METHOD_KEY),
            image: itemImage ? getImageSrc(itemImage.url, ImageSuffix.SmallThumbnail) : '',
            sku,
            link: productLink,
            unitProductType: type.toLowerCase(),
        };
    });
}
export const getHasProductDeliverAtDealerOnly = (entries) => entries.some((entry) => entry.product.variants[0].attributes.find((attribute) => attribute.name === PRODUCT_DELIVER_AT_DEALER_ONLY && attribute.value));
export const checkIsGYTRProduct = (entry) => {
    const isAccessoryOrApparel = entry.productType === ProductType.APPAREL || entry.productType === ProductType.ACCESSORY;
    const masterVariant = getMasterVariant(entry.product.variants);
    const gCoreProductGroupName = masterVariant
        ? getAttributeByName(masterVariant.attributes, G_CORE_PRODUCT_GROUP_NAME)
        : '';
    return isAccessoryOrApparel && gCoreProductGroupName === X20_GROUP_NAME;
};
